import React from "react"
import {
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
  Label,
  Row,
} from "reactstrap"
import mail from "../../assets/images/icons/mail.svg"
import eye from "../../assets/images/icons/eye.svg"
import hide from "../../assets/images/icons/hide.svg"
import { useFormik } from "formik"
import * as Yup from "yup"
import { useUpdatePaswwordMutation } from "store/api/platformManager/platformManager.api"
import toast from "react-hot-toast"
import Spinners from "components/Common/Spinner"
import { useSelector } from "react-redux"

// const defaultValues = {
//   currentPassword: "",
//   password: "",
//   confirmNewPassword: "",
// }

const SystemConfiguration = () => {
  // const [mutate, { isLoading }] = useUpdatePaswwordMutation()
  const user = useSelector((state) => state?.user?.user)
  document.title = "Personal info"

  // const onFormSubmit = async (values) => {
  //   try {
  //     const { message, success } = await mutate(values).unwrap()
  //     if (success) {
  //       toast.success(message, { id: "passwordChangeSuccess" })
  //     }
  //   } catch (error) {
  //     const data = error?.data
  //     if (data?.errors) {
  //       const { errors } = data
  //       validation.setErrors(errors)
  //     }

  //     toast.error(error?.data?.message, { id: "toastMessage" })
  //   }
  // }

  // const validation = useFormik({
  //   enableReinitialize: true,
  //   initialValues: defaultValues,
  //   validationSchema: Yup.object({}),
  //   onSubmit: async (values) => {
  //     await onFormSubmit(values)
  //   },
  // })

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl={12}>
              <div className="platform-heading-section mb-4 pt-4">
                <h4>Personal info</h4>
                <p>Update your personal details here.</p>
              </div>
            </Col>
          </Row>
          <Form
            onSubmit={(e) => {
              e.preventDefault()
              validation.handleSubmit()
              return false
            }}
          >
            <FormGroup row className="mb-4">
              <Label className="form-label" md={4}>
                Name <span className="error">*</span>
              </Label>
              <Col md={6}>
                <Input
                  disabled
                  value={user?.name || ""}
                  id=""
                  name="text"
                  placeholder="Name"
                  type="text"
                  className="form-control"
                />
              </Col>
            </FormGroup>
            <FormGroup row className="mb-4">
              <Label className="form-label" md={4}>
                Email Address <span className="error">*</span>
              </Label>
              <Col md={6}>
                <div className="mail-input-wrapper">
                  <Input
                    disabled
                    id=""
                    value={user?.email || ""}
                    name="text"
                    placeholder="Email Address"
                    type="email"
                    className="form-control"
                  />
                  <img src={mail} alt="" />
                </div>
              </Col>
            </FormGroup>

            {/* <Row>
              <Col xl={12}>
                <div className="platform-heading-section my-4">
                  <h4>Change Password</h4>
                  <p>
                    Please enter your current password to change your password.
                  </p>
                  <hr />
                </div>
              </Col>
            </Row> */}
            {/* <FormGroup row>
              <Label className="form-label" md={4}>
                Current password <span className="error">*</span>
              </Label>
              <Col md={6}>
                <Input
                  id=""
                  name="currentPassword"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.currentPassword}
                  placeholder="Current password"
                  type="password"
                  className="form-control"
                />
                {validation.touched.currentPassword &&
                validation.errors.currentPassword ? (
                  <FormFeedback type="invalid">
                    {validation.errors.currentPassword}
                  </FormFeedback>
                ) : null}
              </Col>
              <hr className="mt-3" />
            </FormGroup> */}

            {/* <FormGroup row>
              <Label className="form-label" md={4}>
                New password <span className="error">*</span>
              </Label>
              <Col md={6}>
                <Input
                  id=""
                  name="password"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.password}
                  placeholder="New password"
                  type="password"
                  className="form-control"
                />

                {validation.touched.password && validation.errors.password ? (
                  <FormFeedback type="invalid">
                    {validation.errors.password}
                  </FormFeedback>
                ) : null}
              </Col>
              <hr className="mt-3" />
            </FormGroup> */}

            {/* <FormGroup row className="mb-2">
              <Label className="form-label" md={4}>
                Confirm new password <span className="error">*</span>
              </Label>
              <Col md={6}>
                <div className="input-wrapper">
                  <Input
                    id=""
                    name="confirmNewPassword"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.confirmNewPassword}
                    placeholder="Confirm new password"
                    type="password"
                    className="form-control"
                  />
                  {validation.touched.confirmNewPassword &&
                  validation.errors.confirmNewPassword ? (
                    <FormFeedback type="invalid">
                      {validation.errors.confirmNewPassword}
                    </FormFeedback>
                  ) : null}
                  <img src={hide} alt="" />
                </div>
              </Col>
            </FormGroup> */}

            {/* <Row className="justify-content-end my-4">
              <Col sm={12}>
                <div className="d-flex justify-content-end align-items-center gap-3">
                  <button type="button" className="btn btn-cancel w-md">
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary w-md"
                    disabled={isLoading}
                  >
                    {isLoading ? <Spinners /> : " Update password"}
                  </button>
                </div>
              </Col>
            </Row> */}
          </Form>
        </Container>
      </div>
    </>
  )
}

export default SystemConfiguration
